export enum ThresholdLevel {
  ON_TARGET = 'ON_TARGET',
  MONITOR = 'MONITOR',
  ATTENTION = 'ATTENTION',
  CRITICAL = 'CRITICAL',
}

export interface ThresholdColors {
  onTarget: string;
  monitor: string;
  attention: string;
  critical: string;
}

export interface IndicatorColors {
  positive: string;
  negative: string;
  neutral: string;
}

export interface ChartColorPalette {
  chartColors: string[];
  threshold: ThresholdColors;
  indicator: IndicatorColors;
}
